import StepEip from '../../../components/step-createEip/createEip.vue' //'../../step-createEip/index.vue';

export default {
    name: 'eipConfig',
    // 继承EIP选配模块
    extends: StepEip
}
